// futureHome Systems Limited logo — recoloured with the ecoHeatwave brand
// palette for the nested-square mark, with the wordmark set in white.
export default function FutureHomeLogo({ size = 32, className = "" }) {
  // ecoHeatwave palette (matches BrandLogo.jsx)
  const goldenSand = "#FFD682"; // outer ring
  const invitingAmber = "#F4B369"; // middle ring
  const sunsetOrange = "#F65900"; // inner ring
  const rusticTerracotta = "#983519"; // centre dot

  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      aria-label="futureHome Systems Limited"
      data-testid="footer-company-logo"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        role="img"
        aria-hidden="true"
        className="shrink-0"
      >
        {/* Outer rounded square — Golden Sand */}
        <rect x="3" y="3" width="42" height="42" rx="7" ry="7"
          fill="none" stroke={goldenSand} strokeWidth="2" />
        {/* Middle rounded square — Inviting Amber */}
        <rect x="11" y="11" width="26" height="26" rx="5" ry="5"
          fill="none" stroke={invitingAmber} strokeWidth="2" />
        {/* Inner rounded square — Sunset Orange */}
        <rect x="18" y="18" width="12" height="12" rx="2.5" ry="2.5"
          fill="none" stroke={sunsetOrange} strokeWidth="2" />
        {/* Centre dot — Rustic Terracotta */}
        <circle cx="24" cy="24" r="2" fill={rusticTerracotta} />
      </svg>

      <span className="leading-tight text-white">
        <span className="block text-[17px] tracking-tight">
          <span className="font-light">future</span>
          <span className="font-medium">Home</span>
          <span className="font-light"> Systems</span>
        </span>
        <span className="block text-[9px] tracking-[0.32em] uppercase text-white/75 mt-0.5">
          Limited
        </span>
      </span>
    </span>
  );
}
